import React from 'react';
import AppHeader from '../components/app-header';
import Icon from '../components/icon';
import PageContainer from './page-container';
import LocalizedStrings from '../localization/strings';

export default class AppContainer extends PageContainer {

    buildTitle(text) {
        if (text) {
            text = `${text.charAt(0).toUpperCase()}${text.slice(1)}`;
            return `${text} | ${window.CARE_CONFIG.settings.title || ''}`;
        }
        return window.CARE_CONFIG.settings.title || '';
    }

    getDocumentTitle(text) {
        return this.buildTitle(text);
    }

    handlePageResult(result) {
        if (result.error) {
            this.openPage('/');
        }
    }

    render() {

        return (
            <div className="app">
                <AppHeader/>
                <div className="site-content">
                    {this.props.children}
                </div>
                <div className="page-section dark footer">
                    <div className="container">
                        <div className="social">
                            {window.CARE_CONFIG.settings.youtube_link
                                ? <a href={window.CARE_CONFIG.settings.youtube_link} target="_blank" aria-label="Youtube">
                                    <Icon icon="youtube" size="sm"/>
                                </a>
                                : null}

                            {window.CARE_CONFIG.settings.facebook_link
                                ? <a href={window.CARE_CONFIG.settings.facebook_link} target="_blank" aria-label="Facebook">
                                    <Icon icon="facebook" size="sm"/>
                                </a>
                                : null}

                            {window.CARE_CONFIG.settings.instagram_link
                                ? <a href={window.CARE_CONFIG.settings.instagram_link} target="_blank" aria-label="Instagram">
                                    <Icon icon="instagram" size="sm"/>
                                </a>
                                : null}

                        </div>
                        <div className="info">
                            {LocalizedStrings.weUsePlatform}:
                            <a href="http://www.eventomania.lt?utm_source=footer" className="footer-logo">
                                <img src={require('../../images/eventomania.png')} alt="Renginių platforma"/></a>
                        </div>
                    </div>

                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/js/containers/app-container.js